module.exports = __webpack_public_path__ + "img/empty-star.8d902cc9.svg";